import { createReducer, on } from '@ngrx/store';
import { setBrokerSessionInfo, setUserGroups } from './auth.actions';

export const brokerSessionInitialState: string = JSON.parse(localStorage.getItem('brokerSessionInfo'));
export const userGroupsInitialState: string = JSON.parse(localStorage.getItem('userGroups'));

export const brokerSessionInfoReducer = createReducer(
  brokerSessionInitialState,
  on(setBrokerSessionInfo, (state, { brokerSessionInfo }) => brokerSessionInfo)
);

export const userGroupsReducer = createReducer(
  userGroupsInitialState,
  on(setUserGroups, (state, { userGroups }) => userGroups)
);
